var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommitment1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Commitment-1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Commitment-1",
    clipPath: "url(#clip-Commitment-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12205",
    "data-name": "Group 12205",
    transform: "translate(12.633 18.464)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13002",
    "data-name": "Path 13002",
    d: "M693.1,827.644c.917-6.492,4.093-11.01,9.932-13.5a10.334,10.334,0,0,1,3.065-.867c1.356-.12,1.682-.76,1.578-1.969a8.893,8.893,0,0,1,.047-2.684c.117-.515.745-.914,1.143-1.366.4.458,1.08.884,1.137,1.381a38.6,38.6,0,0,1,.055,4.292,16.174,16.174,0,0,1,11.236,5.936,2.945,2.945,0,0,1-.444.385c-.493.261-1,.5-1.592.794-.409-.366-.822-.724-1.223-1.1a13.4,13.4,0,1,0,4.331,10.182c.007-.393.006-.787-.013-1.18-.1-2.079-.106-2.078,1.842-2.887.062.073.2.156.2.24-.005,2.223,1.3,2.641,3.167,2.344a2.391,2.391,0,0,1,1.33.028,8.67,8.67,0,0,1,1.491,1.181c-.513.394-.991,1.053-1.547,1.128a30.633,30.633,0,0,1-3.984.054,16.073,16.073,0,0,1-14.78,14.64c0,1.327,0,2.552,0,3.776,0,.879-.008,1.826-1.168,1.872-1.191.047-1.237-.9-1.24-1.783,0-1.231,0-2.462,0-3.795-8.26-1.433-13.182-6.158-14.584-14.715a31.61,31.61,0,0,1-4.065-.055c-.612-.079-1.148-.747-1.718-1.148.563-.4,1.093-1.056,1.7-1.136A31.963,31.963,0,0,1,693.1,827.644Z",
    transform: "translate(-687.288 -807.26)",
    fill: "#F6911E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13003",
    "data-name": "Path 13003",
    d: "M741.287,833.7a3.266,3.266,0,0,1,4.845-2.982,2.492,2.492,0,0,0,2.622-.034q7.344-3.76,14.722-7.457a6.094,6.094,0,0,0,3.467-4.291c.059-.271.085-.679.262-.775,2.245-1.23,4.51-2.424,6.806-3.556.054-.026.819.854.732,1.163-.657,2.317.13,3.718,2.355,4.591.975.383.942,1.2-.056,1.729-1.838.965-3.675,1.936-5.554,2.816a1.887,1.887,0,0,1-1.415-.089,6.041,6.041,0,0,0-5.652.2c-4.948,2.525-9.929,4.988-14.842,7.579a4.145,4.145,0,0,0-1.691,2.038,3.415,3.415,0,0,1-3.977,2.3A3.187,3.187,0,0,1,741.287,833.7Z",
    transform: "translate(-723.074 -812.129)",
    fill: "#F6911E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13004",
    "data-name": "Path 13004",
    d: "M737.847,842.973a2.588,2.588,0,0,1-3.6.238,7.853,7.853,0,0,0-9.5,1.149,8.191,8.191,0,0,0,6.869,14.087,7.991,7.991,0,0,0,6.74-6.619c.193-1.514.777-2.361,2.216-2.669,1.389,3-1.1,8.215-5.01,10.434a10.618,10.618,0,0,1-11.722-17.642A10.486,10.486,0,0,1,737.847,842.973Z",
    transform: "translate(-708.788 -828.79)",
    fill: "#F6911E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommitment1);
export default __webpack_public_path__ + "static/media/commitment-1.56fb15833777907794dd5619f8d3b090.svg";
export { ForwardRef as ReactComponent };